var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 57,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#play_svg__a)",
    d: "M123.457 28.534C123.454 13.29 111.099.933 95.855.93h-73.32a3.539 3.539 0 1 0 0 7.079h26.919a2.486 2.486 0 0 1 2.486 2.485 2.48 2.48 0 0 1-2.483 2.482l-1.77-.014-34.33-.003a3.539 3.539 0 1 0 0 7.078l36.951-.003h1.208A2.486 2.486 0 0 1 54 22.522a2.48 2.48 0 0 1-2.482 2.482l-1.882-.015H3.926a3.539 3.539 0 1 0 0 7.079h45.711l3.124-.015a2.48 2.48 0 0 1 2.482 2.483 2.486 2.486 0 0 1-2.485 2.485l-.85.003H19.84a3.539 3.539 0 1 0 0 7.078h29.746a2.486 2.486 0 0 1 0 4.97l-2.821-.011-19.166-.003a3.54 3.54 0 0 0-3.54 3.54 3.543 3.543 0 0 0 3.54 3.539l68.252.003c15.244-.003 27.602-12.362 27.602-27.603z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104 28 83.75 41.856V14.144z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "play_svg__a",
    x1: 31.357,
    x2: 99.533,
    y1: 61.353,
    y2: -6.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })))));
};
export default SvgPlay;